// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "meta_ad_account_health".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "meta_ad_account_health" table (1:1 with a DB row, on the wire). */
export const metaAdAccountHealthAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    adAccountId: z.string(),
    state: z.string(),
    reasons: z.array(z.string()),
    accountStatus: z.number().nullable(),
    disableReason: z.number().nullable(),
    currency: z.string().nullable(),
    balance: z.number().nullable(),
    amountSpent: z.number().nullable(),
    spendCap: z.number().nullable(),
    hasFundingSource: z.boolean().nullable(),
    lastError: z.string().nullable(),
    checkedAt: z.string().datetime(),
    stateChangedAt: z.string().datetime(),
    previousState: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=metaAdAccountHealth.js.map